// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header_header__PBNgB {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
}

.Header_logoContainer__\\+jzI8 {
  display: flex;
  align-items: center;
  gap: 20px;
}

.Header_deletePadding__uzR2B {
  padding-left: 5px;
  padding-right: 5px;
}

.Header_logoLink__BdSMX {
  display: flex;
}

.Header_logo__Jd5O1 {
  display: none;
  margin-right: 5px;
}
@media (min-width: 1023px) {
  .Header_logo__Jd5O1 {
    display: block;
  }
}
.Header_logoClient__2\\+tGY {
  margin-left: 1rem;
}
@media (min-width: 720px) {
  .Header_logoClient__2\\+tGY {
    padding-left: 1rem;
    border-left: solid 1px #dbdbdb;
  }
}

.Header_logoMedium__yxPJV {
  display: none;
}
@media (min-width: 720px) {
  .Header_logoMedium__yxPJV {
    display: block;
  }
}
@media (min-width: 1023px) {
  .Header_logoMedium__yxPJV {
    display: none;
  }
}

@media (min-width: 720px) {
  .Header_logoMobile__QmImS {
    display: none;
  }
}

.Header_navTabs__Vk0dW {
  font-size: 1.4em;
  display: flex;
  align-self: center;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin-left: 20%;
  color: var(--font-primary-color);
  min-width: 480px;
}
@media (min-width: 320px) {
  .Header_navTabs__Vk0dW {
    display: none;
  }
}
@media (min-width: 1360px) {
  .Header_navTabs__Vk0dW {
    display: flex;
  }
}
.Header_navTabs__Vk0dW a {
  color: var(--primary-color) !important;
  font-weight: bold;
  text-decoration-thickness: 3px !important;
  white-space: nowrap;
}

.Header_nav__gHdSw {
  display: flex;
  align-items: center;
  gap: 20px;
}
@media (min-width: 320px) {
  .Header_nav__gHdSw {
    gap: 30px;
  }
}
.Header_nav__gHdSw .Header_userLogged__ihowo {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
}
.Header_nav__gHdSw .Header_userLogged__ihowo .Header_avatar__9AMsJ {
  border-radius: 50%;
  border: 3px solid var(--accent-color);
  width: 32px;
  height: 32px;
  background-size: cover;
  background-position: center;
}
.Header_nav__gHdSw .Header_buttons__e04qp {
  display: flex;
  gap: 20px;
}
@media (min-width: 320px) {
  .Header_nav__gHdSw .Header_buttons__e04qp {
    gap: 22px;
  }
}

@media (min-width: 320px) {
  .Header_buttonTitle__BVmWb {
    display: none;
  }
}
@media (min-width: 720px) {
  .Header_buttonTitle__BVmWb {
    display: block;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/Header/Header.module.scss","webpack://./src/_common/scss/_media.scss","webpack://./src/_common/scss/_colors.scss"],"names":[],"mappings":"AAIA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;AAHF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAHF;;AAMA;EACE,iBAAA;EACA,kBAAA;AAHF;;AAMA;EACE,aAAA;AAHF;;AAMA;EACE,aAAA;EACA,iBAAA;AAHF;ACFI;EDGJ;IAKI,cAAA;EAFF;AACF;AAIE;EACE,iBAAA;AAFJ;ACdI;EDeF;IAII,kBAAA;IACA,8BAAA;EADJ;AACF;;AAKA;EACE,aAAA;AAFF;ACxBI;EDyBJ;IAII,cAAA;EADF;AACF;ACzBI;EDqBJ;IAQI,aAAA;EAAF;AACF;;AClCI;EDqCJ;IAEI,aAAA;EAAF;AACF;;AAGA;EACE,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;EACA,gCEnEa;EFoEb,gBAAA;AAAF;AC5DI;EDmDJ;IAYI,aAAA;EACF;AACF;ACjDI;EDmCJ;IAgBI,aAAA;EAEF;AACF;AAAE;EACE,sCAAA;EACA,iBAAA;EACA,yCAAA;EACA,mBAAA;AAEJ;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AACF;AClFI;ED8EJ;IAMI,SAAA;EAEF;AACF;AAAE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;AAEJ;AAAI;EACE,kBAAA;EACA,qCAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,2BAAA;AAEN;AAEE;EACE,aAAA;EACA,SAAA;AAAJ;ACzGI;EDuGF;IAKI,SAAA;EACJ;AACF;;AC9GI;EDiHJ;IAEI,aAAA;EAAF;AACF;AC5GI;EDyGJ;IAMI,cAAA;EACF;AACF","sourcesContent":["@import '@common/scss/_colors';\n@import '@common/scss/_variables';\n@import '@common/scss/_media';\n\n.header {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n}\n\n.logoContainer {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.deletePadding {\n  padding-left: 5px;\n  padding-right: 5px;\n}\n\n.logoLink {\n  display: flex;\n}\n\n.logo {\n  display: none;\n  margin-right: 5px;\n\n  @include media(md) {\n    display: block;\n  }\n\n  &Client {\n    margin-left: 1rem;\n\n    @include media(sm) {\n      padding-left: 1rem;\n      border-left: solid 1px $grey-200;\n    }\n  }\n}\n\n.logoMedium {\n  display: none;\n\n  @include media(sm) {\n    display: block;\n  }\n\n  @include media(md) {\n    display: none;\n  }\n}\n\n.logoMobile {\n  @include media(sm) {\n    display: none;\n  }\n}\n\n.navTabs {\n  font-size: 1.4em;\n  display: flex;\n  align-self: center;\n  align-items: center;\n  justify-content: center;\n  gap: 20px;\n  margin-left: 20%;\n  color: $font-primary;\n  min-width: 480px;\n\n  @include media(xss) {\n    display: none;\n  }\n\n  @include media(lg) {\n    display: flex;\n  }\n\n  a {\n    color: $primary !important;\n    font-weight: bold;\n    text-decoration-thickness: 3px !important;\n    white-space: nowrap;\n  }\n}\n\n.nav {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n\n  @include media(xss) {\n    gap: 30px;\n  }\n\n  & .userLogged {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 10px;\n\n    .avatar {\n      border-radius: 50%;\n      border: 3px solid $accent;\n      width: 32px;\n      height: 32px;\n      background-size: cover;\n      background-position: center;\n    }\n  }\n\n  & .buttons {\n    display: flex;\n    gap: 20px;\n\n    @include media(xss) {\n      gap: 22px;\n    }\n  }\n}\n\n.buttonTitle {\n  @include media(xss) {\n    display: none;\n  }\n\n  @include media(sm) {\n    display: block;\n  }\n}\n","// variables:\n$breakpoint-xss: 320px;\n$breakpoint-xs: 480px;\n$breakpoint-sm: 720px;\n$breakpoint-md: 1023px;\n$breakpoint-lg: 1360px;\n$breakpoint-xl: 1600px;\n\n@mixin media($media) {\n  // MOBILE FIRST\n  @if $media == xss {\n    @media (min-width: $breakpoint-xss) {\n      @content;\n    }\n  } @else if $media == xs {\n    @media (min-width: $breakpoint-xs) {\n      @content;\n    }\n  } @else if $media == sm {\n    @media (min-width: $breakpoint-sm) {\n      @content;\n    }\n  } @else if $media == md {\n    @media (min-width: $breakpoint-md) {\n      @content;\n    }\n  } @else if $media == lg {\n    @media (min-width: $breakpoint-lg) {\n      @content;\n    }\n  }\n}\n","$primary: var(--primary-color);\n$secondary: var(--secondary-color);\n$accent: var(--accent-color);\n$font-primary: var(--font-primary-color);\n$font-secondary: var(--font-secondary-color);\n$font-accent: var(--font-accent-color);\n$grey-100: #f4f5f7;\n$grey-200: #dbdbdb;\n$grey-300: #acacac;\n$grey-400: #838383;\n$chart-dataset-1: #df6767;\n$chart-dataset-2: #efa12c;\n$warning: orange;\n$error: #df6767;\n$white: #fff;\n$transparent: transparent;\n\n$primary-font-color: #fff;\n$secondary-font-color: #fff;\n$accent-font-color: #fff;\n$warning-font-color: #fff;\n$error-font-color: #fff;\n$filter-bg: #fff;\n\n$bg-main: var(--background-color);\n$card-bg: #fff;\n$default-control-bg: #fff;\n$card-shadow: 3px 3px 3px -1px rgba(0, 0, 0, 0.1);\n$default-shadow-color: rgba(0, 0, 0, 0.1);\n\n$default-border-color: #acacac;\n$default-backdrop-color: rgba(0, 0, 0, 0.8);\n\n$default-navbar-color: #fff;\n\n$stats-card-bg-color: #fff;\n$stats-card-color: #000;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `Header_header__PBNgB`,
	"logoContainer": `Header_logoContainer__+jzI8`,
	"deletePadding": `Header_deletePadding__uzR2B`,
	"logoLink": `Header_logoLink__BdSMX`,
	"logo": `Header_logo__Jd5O1`,
	"logoClient": `Header_logoClient__2+tGY`,
	"logoMedium": `Header_logoMedium__yxPJV`,
	"logoMobile": `Header_logoMobile__QmImS`,
	"navTabs": `Header_navTabs__Vk0dW`,
	"nav": `Header_nav__gHdSw`,
	"userLogged": `Header_userLogged__ihowo`,
	"avatar": `Header_avatar__9AMsJ`,
	"buttons": `Header_buttons__e04qp`,
	"buttonTitle": `Header_buttonTitle__BVmWb`
};
export default ___CSS_LOADER_EXPORT___;
